module.exports = __webpack_public_path__ + "school/fonts/HYQuanTangShiJ.a9a0606d.ttf";